module.exports = __webpack_public_path__ + "img/int.0eeb94e0.png";